<!-- eslint-disable vue/valid-template-root -->
<script>
import { title } from '@src/app.config'

export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  mounted() {
    document.title = this.title ? this.title + ' | ' + title : title
  },
  unmounted() {
    document.title = title
  },
}
</script>

<template />
